var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMouseTradeButton = props => /*#__PURE__*/React.createElement("svg", _extends({
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M10.5 1H5V0h5.5a1.5 1.5 0 0 1 0 3H10a1 1 0 0 0-1 1h2a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2a2 2 0 0 1 2-2h.5a.5.5 0 0 0 0-1M8 5H6a1 1 0 0 0-1 1v3h3zm1 4h3V6a1 1 0 0 0-1-1H9zm3 1H5v4a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1z",
  clipRule: "evenodd"
})));
export default SvgMouseTradeButton;